import type { ReactElement } from 'react';
import { PackageContainer } from '../common/PackageContainer';
import { PackageDetails } from '../common/PackageDetails';
import { PackageGroup } from '../common/PackageGroup';
import { PackagesByCategory } from '../common/PackagesByCategory';
import { VenuePackageCategoryLabels } from 'packages/enums';
import type {
  VenuePackage,
  Service,
  PackageSelectComponent,
  Package
} from 'packages/types';

type Props = {
  packages: VenuePackage[];
  allServices: Service[];
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

type SinglePackageProps = {
  pkg: VenuePackage;
  allServices: Service[];
  PackageSelectComponent?: PackageSelectComponent;
  onPackageViewed?: (pkg: Package) => void;
};

function SinglePackage(props: SinglePackageProps) {
  return (
    <PackageContainer pkg={props.pkg} onPackageViewed={props.onPackageViewed}>
      <PackageDetails
        pkg={props.pkg}
        allServices={props.allServices}
        PackageSelectComponent={props.PackageSelectComponent}
      />
    </PackageContainer>
  );
}

export function VenuePackageList(props: Props): ReactElement {
  return (
    <PackagesByCategory
      categoryLabels={VenuePackageCategoryLabels}
      packages={props.packages}
      PackageGroup={PackageGroup}
      Package={SinglePackage}
      packageProps={{
        allServices: props.allServices,
        PackageSelectComponent: props.PackageSelectComponent,
        onPackageViewed: props.onPackageViewed
      }}
    />
  );
}
